import { render, staticRenderFns } from "./TeamTalk.vue?vue&type=template&id=62a57bfa&scoped=true&"
import script from "./TeamTalk.vue?vue&type=script&lang=js&"
export * from "./TeamTalk.vue?vue&type=script&lang=js&"
import style0 from "./TeamTalk.vue?vue&type=style&index=0&id=62a57bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a57bfa",
  null
  
)

export default component.exports